import React from "react";
import LgStatus from "../components/LgStatus/LgStatus";
import { LgStatusService } from "../services/service.lgStatus";
import { toast } from "react-toastify";

class LgStatusContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: false,
            searchValue: "",
            searchType: "shipmentId",
            statusData: null,
            errorMessage: null,
            olpnSize: 10
        };
    }

    handleSearchValueChange = (value) => {
        this.setState({ searchValue: value, errorMessage: null });
    };

    handleSearchTypeChange = (value) => {
        this.setState({
            searchType: value,
            searchValue: "",
            statusData: null,
            errorMessage: null
        });
    };

    handleOlpnSizeChange = (newSize) => {
        const size = Number(newSize);
        if (!size || isNaN(size)) return;
        this.setState({ olpnSize: size }, () => {
            const { searchValue } = this.state;
            if (searchValue && searchValue.trim().length > 0) {
                this.handleSearch();
            }
        });
    };

    handleSearch = async () => {
        const { searchValue, searchType, olpnSize } = this.state;
        const { dcValue } = this.props;

        if (!searchValue || searchValue.trim().length === 0) {
            toast.error(searchType === 'shipmentId'
                ? "Please enter a Shipment ID"
                : "Please enter a Loading Group ID");
            return;
        }

        this.setState({ showSpinner: true, errorMessage: null, statusData: null });

        try {
            const response = await LgStatusService.getLgStatus(
                searchValue.trim(), searchType, dcValue, 0, olpnSize
            );

            if (response.status === 200 && response.data) {
                this.setState({ statusData: response.data });
                const lgCount = response.data.loading_groups?.length || 0;
                toast.success(`Found ${lgCount} loading group(s)`);
            } else {
                this.setState({ errorMessage: "No data found for the provided search criteria" });
                toast.error("No data found");
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message ||
                error.message ||
                "Failed to fetch loading group status. Please try again.";
            this.setState({ errorMessage: errorMsg });
            toast.error(errorMsg);
        } finally {
            this.setState({ showSpinner: false });
        }
    };

    // Called by each LgCard when the user navigates to a different OLPN page.
    // Searches by the specific LG ID so only that card's OLPNs are refreshed.
    handleFetchOlpnPage = async (lgId, page) => {
        const { olpnSize } = this.state;
        const { dcValue } = this.props;

        try {
            const response = await LgStatusService.getLgStatus(
                lgId, 'lgId', dcValue, page, olpnSize
            );

            if (response.status === 200 && response.data) {
                const updatedLg = response.data.loading_groups?.[0];
                if (updatedLg) {
                    this.setState((prev) => ({
                        statusData: {
                            ...prev.statusData,
                            loading_groups: prev.statusData.loading_groups.map((lg) =>
                                lg.loading_group_id === lgId ? { ...lg, ...updatedLg } : lg
                            )
                        }
                    }));
                }
            } else {
                toast.error(`No OLPN data for page ${page + 1}`);
            }
        } catch (error) {
            toast.error(`Failed to load OLPNs page ${page + 1}`);
        }
    };

    render() {
        return (
            <LgStatus
                showSpinner={this.state.showSpinner}
                searchValue={this.state.searchValue}
                searchType={this.state.searchType}
                olpnSize={this.state.olpnSize}
                onSearchValueChange={this.handleSearchValueChange}
                onSearchTypeChange={this.handleSearchTypeChange}
                onOlpnSizeChange={this.handleOlpnSizeChange}
                handleSearch={this.handleSearch}
                onFetchOlpnPage={this.handleFetchOlpnPage}
                statusData={this.state.statusData}
                errorMessage={this.state.errorMessage}
                dcValue={this.props.dcValue}
            />
        );
    }
}

export default LgStatusContainer;
